import { Property } from './property';

export class ComparableMultipliers {
    constructor(doc) {
        this.comparableMultiplierList = [];
        for (let property of doc) {
            this.comparableMultiplierList.push(new ComparableMultiplier(property));
        }
    }

    getPropertyImages() {
        const images = [];
        const title = "Comparable #";
        let index = 0;
        for (let property of this.comparableMultiplierList) {
            const img = property.getPropertyImage();
            img.imageSourceCaption = title + (++index).toString();
            images.push(property.getPropertyImage());
        }
        return images;
    }
}

export class ComparableMultiplier extends Property {
    // constructor(doc) {
    //     super(doc);
    // }
}
